module.exports = __webpack_public_path__ + "static/media/climbing_view_1920.699b5df0.jpg";